
import CommonUtils from "@/common-utils";
import axios from "axios";
import { Component, Prop, Vue } from "vue-property-decorator";
import firebase from "firebase/app";
import Criteo from "@/criteo";
import { CriteoVO } from "@/vo/criteo.vo";
import { MobionVO } from "@/vo/mobion.vo";
import { FacebookVO, ContentsVO} from "@/vo/facebook.vo";
import AdLogs from "@/ad-logs";
import { MstOrderVO, RelOrderProductVO } from "./vo/order.vo";

@Component
export default class PaymentComplete extends Vue {
  @Prop() orderCd;
  goMain(): void {
    this.$router.push({ name: "Main" });
  }

  goMypge(): void {
    this.$router.push({ name: "OrderDetails", params: { orderCd: this.orderCd } });
  }

  order = {} as MstOrderVO;
  products = [] as Array<RelOrderProductVO>;
  paymentFailed = false as boolean;

  get resMsg() {
    return this.$route.query.resMsg;
  }

  // 화면 보여줌? pc웹에서 부모창이 있을 경우 안보여줌
  get showScreen() {
    //console.log(window.opener);
    return !window.opener;
  }

  get productInfo(): object {
    const productNm = this.products[0]?.productNm || '';
    const productOther = this.products.length > 1 ? ` 외 ${this.products.length - 1} 건` : '';
    return {productNm, productOther};
  }

  beforeCreate() {
    let realUrl = '';
    if (window.opener) {
      realUrl = this.$route.fullPath
      window.opener.location.href =
      process.env.VUE_APP_MAIN_URL+ "order/payment-complete/";
      window.close();
    }
    // 주문번호붙은 redirect url이 카드결제창으로 리다이렉트 가서 
    // 그 주소를 받아 추가작업하는 코드..
    if(realUrl){
      const subStrRealUrl = realUrl.substring(1);
      const finalUrl =  process.env.VUE_APP_MAIN_URL + subStrRealUrl;
      window.opener.location.href = finalUrl;
    }
   
  }

  fbPixelParams(data: any): object {
    const { currency, transaction_id, value, items, zip_code, email } = data;
    const contents = [] as ContentsVO[];
    items.forEach((item) => {
      const obj = {} as ContentsVO;
      obj.id = item.item_id;
      obj.quantity = item.quantity;
      contents.push(obj);
    });
    return {
      content_ids: transaction_id,
      content_type: "product",
      value,
      contents,
      currency,
      zip_code: zip_code,
      email : email,
    } as FacebookVO;
  }

  kakaoPixelParams(data: any): object {
    const { currency, transaction_id, value, items } = data;
    const contents = [] as ContentsVO[];
    let totalQuantity = 0;
    items.forEach((item) => {
      const obj = {} as ContentsVO;
      obj.id = item.item_id;
      obj.name = item.item_name;
      obj.quantity = item.quantity;
      contents.push(obj);
      totalQuantity+=item.quantity;
    });
    return {
      total_quantity: totalQuantity,
      total_price: value,
      currency,
      contents,
      tag: transaction_id,
    }
  }

  mobionParams(data: any): object{
    const { currency, transaction_id, value, items } = data;
    const product = [] as MobionVO[];
    let totalQuantity = 0; 
    items.forEach((item) => {
      const obj = {} as MobionVO;
      obj.productCode = item.item_id;
      obj.productName = item.item_name;
      obj.qty = item.quantity;
      obj.price = item.value;
      product.push(obj);
      totalQuantity+=item.quantity;
    });
      return {
      convType: "purchase",
      totalQty : totalQuantity,
      totalPrice : value,
      currency,
      product,
      ordCode: transaction_id,
    }

  }
  async sendMarketingdata(){
 // TODO 나중에 위 GA어떻게 해야됨?
    await axios.get("/order/analytics/purchase/" + this.orderCd).then((r) => {
      const ecommerce = r.data;
      CommonUtils.sendCommonEventLogs(
        this,
        firebase.analytics.EventName.PURCHASE,
        ecommerce
      );
      
      // 페이스북 픽셀 결제완료 추가 태그
      AdLogs.sendMetaPixelEventLogs("Purchase", this.fbPixelParams(ecommerce));
      AdLogs.sendMetaPixelEventLogs("Purchase_Sec", this.fbPixelParams(ecommerce));
  
      // 카카오 픽셀
      AdLogs.sendKakaoPixelEventLogs("Purchase", this.kakaoPixelParams(ecommerce))
      
      //모비온 광고
      AdLogs.sendMobionPurchase(this.mobionParams(ecommerce));
      //naver
      CommonUtils.sendNaverLogEvent(1, ecommerce.value);

      //크리테오 결제완료
      Criteo.putQuery({
        path: "",
        transactionId: r.data.transaction_id,
        oneTag: Criteo.criteoTags.SALES_TAG,
        data: r.data.items,
      } as CriteoVO);
      
    });

    // GA
      this.$gtm?.dataLayer() &&
        await axios.get("/order/purchase/" + this.orderCd).then((r) => {
        const ecommerce = r.data;
        if (ecommerce) {
          this.$gtm
            .dataLayer()
            .push({ event: "purchase", ecommerce: ecommerce });
        }

      })
  }
  
  async created() {
    if (!this.orderCd) {
      return;
    }


  this.paymentFailed = this.$route.query.success === 'failed'
 

    await axios.get(`/mypage/order/${this.orderCd}`).then(
      (r) => {
        if (r.data.order) {
          this.order = r.data.order;
          this.products = r.data.products;
        
          // 새로고침시 파이어베이스 등 무제한 api 호출 방지 코드
          if (
            localStorage.getItem("orderCd") &&
            this.orderCd == localStorage.getItem("orderCd")
          ) {
          return;
          } else if(this.orderCd && this.orderCd != localStorage.getItem("orderCd")) {
            this.sendMarketingdata()
            localStorage.setItem("orderCd", this.orderCd);
          }
        
        } else {
          this.$router.push("/mypage/order/orders/all");
        }
      },
      () => {
        alert(this.$t("common.a0001"));
      }
    )
  }
}
